// DoctorconsoleHeader.styles.js
export const styles = {
  card: {
    p: 1,
    borderRadius: "20px",
    bgcolor: "#F0F8F0",
    boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
    justifyContent: "center",
  },
  avatar: {
    bgcolor: "#e0e0e0",
    width: 40,
    height: 40,
    mr: 1,
  },
  patientName: {
    color: "#121959",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    textTransform: "uppercase",
    lineHeight: "20px",
    // fontFamily: "Roboto",
    // fontWeight: 700,
    // fontSize: "24px",
    // {
    //   xs: "18px", // small screens
    //   sm: "18px",
    //   md: "22px", // larger screens
    //   lg: "24px", // desktops
    //   xl: "px",
    // },
    // lineHeight: "100%",
    // letterSpacing: 0,
    // color: "#121959",
  },
  ageGenderText: {
    color: "#000",
    fontFamily: "Roboto",
    fontSize: "16px",
    // {
    //   xs: "14px",
    //   sm: "16px",
    //   md: "20px",
    // },
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  visitPurposeLabel: {
    color: "#000",
    fontFamily: "Roboto",
    fontSize: "16px",
    // {
    //   xs: "14px",
    //   sm: "16px",
    //   md: "20px",
    // },
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
  select: {
    color: "black",
    minWidth: { xs: "100px", sm: "150px", md: "200px" },
    maxWidth: "auto",
  },
  addIcon: {
    width: 24,
    height: 24,
  },
  divider: {
    marginLeft: 1,
    marginRight: 1,
    color: "rgba(0, 0, 0, 0.25)",
    width: "1px",
  },
};
